var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#034A73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19H13C11.3464 19 10 17.6536 10 16V13C10 11.3464 11.3464 10 13 10H16C17.6536 10 19 11.3464 19 13V16C19 17.6536 17.6536 19 16 19ZM13 11.2C12.0076 11.2 11.2 12.0076 11.2 13V16C11.2 16.9924 12.0076 17.8 13 17.8H16C16.9924 17.8 17.8 16.9924 17.8 16V13C17.8 12.0076 16.9924 11.2 16 11.2H13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19H24C22.3452 19 21 17.6548 21 16V13C21 11.3464 22.3452 10 24 10H27C28.6548 10 30 11.3464 30 13V16C30 17.6548 28.6548 19 27 19ZM24 11.2C23.0076 11.2 22.2 12.0076 22.2 13V16C22.2 16.9924 23.0076 17.8 24 17.8H27C27.9924 17.8 28.8 16.9924 28.8 16V13C28.8 12.0076 27.9924 11.2 27 11.2H24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30H24C22.3452 30 21 28.6548 21 27V24C21 22.3452 22.3452 21 24 21H27C28.6548 21 30 22.3452 30 24V27C30 28.6548 28.6548 30 27 30ZM24 22.2C23.0076 22.2 22.2 23.0076 22.2 24V27C22.2 27.9924 23.0076 28.8 24 28.8H27C27.9924 28.8 28.8 27.9924 28.8 27V24C28.8 23.0076 27.9924 22.2 27 22.2H24Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30H13C11.3452 30 10 28.6548 10 27V24C10 22.3452 11.3452 21 13 21H16C17.6548 21 19 22.3452 19 24V27C19 28.6548 17.6548 30 16 30ZM13 22.2C12.0076 22.2 11.2 23.0076 11.2 24V27C11.2 27.9924 12.0076 28.8 13 28.8H16C16.9924 28.8 17.8 27.9924 17.8 27V24C17.8 23.0076 16.9924 22.2 16 22.2H13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickOption);
export default __webpack_public_path__ + "static/media/quickOption.7a1361374752d9245daa410e96b665f4.svg";
export { ForwardRef as ReactComponent };